exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".selfie-page {\n  margin-left: 200px;\n  min-height: 100vh;\n  background-color: #f2f2f2;\n  padding-left: 22px;\n  padding-right: 30px;\n  padding-top: 50px; }\n", ""]);

